// The pages listed on /studies, in the order they appear there.
//
// They used to sit in Home's own ALL_PAGES; they were moved here on 2026-10-18
// so Home carries one "Brookline Notepad Studies" card in their place and the two
// lists cannot drift apart. Each entry is the same shape Home uses:
// {path, title, description, icon}.
//
// Mixed access: the massing study is public, the two comparisons are private,
// and PageDirectory filters the list per visitor.
export const STUDY_PAGES = [
  {
    path: '/26-pleasant-st-massing-study',
    title: '26 Pleasant Street Massing Study',
    description: 'What the proposed Pleasant Street Multifamily Overlay District would allow on the lot - interactive models and drawings',
    icon: '🏗️',
  },
  {
    path: '/school-staff',
    title: 'School Staff vs. Population',
    description: 'School department staffing compared to population for Brookline & comparable MA communities',
    icon: '📊',
  },
  {
    path: '/town-budgets',
    title: 'Town Budgets vs. Population',
    description: 'FY2026 operating budgets compared to population for Brookline & comparable MA communities',
    icon: '💰',
  }
];
